import LTR from "@brand-icons/global/subscription-default/subscription-default-ltr.svg";
import RTL from "@brand-icons/global/subscription-default/subscription-default-rtl.svg";

import { iconFactory } from "../iconFactory";

export const SubscriptionDefaultIcon = iconFactory("SubscriptionDefaultIcon", LTR, RTL);
